import './RightPanel.scss';
import { PanelDetails } from './RightPanelDetails';
import { ReactNode } from 'react';

interface RightPanelControlledProps {
  children?: ReactNode;
  isVisible: boolean;
  isPinned: boolean;
  onClose: () => void;
  onOpen?: () => void;
  onPin?: (pinned: boolean) => void;
  includePin?: boolean;
  title?: string;
}

export const RightPanelControlled = ({ children, isVisible, isPinned, onClose, onOpen, onPin, includePin = true, title = 'Elementos' }: RightPanelControlledProps) => {
  return (
    <PanelDetails isVisible={isVisible} isPinned={isPinned} onClose={onClose} onOpen={onOpen} onPin={onPin} includePin={includePin} title={title}>
      {children}
    </PanelDetails>
  );
};
